// @flow
import React, { useState, useEffect } from 'react';

// import OptFillQuestion from "./OptFillQuestion";

import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { apiRefresh } from '../services/api';
import history from '../services/history';

// Fetch the user's permissions and stash them in localStorage. No routing —
// callers that need to land somewhere afterwards do that themselves.
//
// Split out of getUserBranchPermissions so login can populate these same two
// keys before handing the session to the New UI. They are not optional: App.js
// (componentWillMount) clears the WHOLE session on next boot when
// `userBranchPermissions` is missing, so a login that skips this logs the user
// out of the legacy app the moment they come back to it.
export function loadUserPermissions() {
  return new Promise((resolve, reject) => {
    const userBranchPermissionsOpt = {
      url: `v1/user/permission`,
    };
    userBranchPermissionsOpt.types = [
      'GET_USER_BRANCH_PERMISSIONS_SUCCESS',
      'GET_USER_BRANCH_PERMISSIONS_FAILURE',
    ];

    apiRefresh
      .get(userBranchPermissionsOpt)
      .then((res) => {
        if (res && res.length > 0) {
          // Normalise to arrays before storing. The API returns `null` for
          // these when a user or branch has no permissions, and
          // `JSON.stringify(null)` is the STRING "null" — which base64s to a
          // truthy "bnVsbA==". Every consumer guards on presence only
          // (`localStorage.getItem(k) && JSON.parse(k).find(...)`), so the
          // guard passes, the parse yields null, and `.find` throws
          // "Cannot read properties of null (reading 'find')" — App.js:124 in
          // componentWillMount, ~30 sites in SideBar.js, DashboardBi.js,
          // HeaderTabs.js. Fixing it here, where the data enters localStorage,
          // covers all of them without touching any gating logic, and mirrors
          // what the New UI already does in features/auth/use-user-access.ts.
          const sys = Array.isArray(res[0].userSystemPermissions)
            ? res[0].userSystemPermissions
            : [];
          const bpRaw = res[0].branchPermissions || {};
          const bp = {
            ...bpRaw,
            branchPermission: Array.isArray(bpRaw.branchPermission) ? bpRaw.branchPermission : [],
          };
          var systemPermissions = JSON.stringify(sys);
          var branchPermissions = JSON.stringify(bp);
          localStorage.setItem(
            'userSystemPermissions',
            btoa(unescape(encodeURIComponent(systemPermissions)))
          );
          localStorage.setItem(
            'userBranchPermissions',
            btoa(unescape(encodeURIComponent(branchPermissions)))
          );
          resolve();
        } else {
          reject('No permission response');
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function getUserBranchPermissions(history) {
  return loadUserPermissions().then(() => {
    if (
      localStorage.getItem('isAgent') === 'true' ||
      (localStorage.getItem('userType') &&
        localStorage.getItem('userType').toLowerCase() === 'sales person')
    ) {
      history.push('/potential-client/potential-clients');
    } else {
      history.push('/dashboardBI');
    }
  });
}

export default getUserBranchPermissions;
